import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CommunityProvider } from './contexts/CommunityContext';
import { NotificationProvider } from './contexts/NotificationContext';

// Components
import NavigationBar from './shared/NavigationBar';

// Pages
import CommunityLayout from './pages/CommunityLayout';
import TestPage from './pages/TestPage';

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <CommunityProvider>
          <Router>
            <div className="min-h-screen">
              <NavigationBar />
              <main className="pt-11">
                <Routes>
                  {/* Test Page - 테스트용 (변경사항 먼저 테스트) */}
                  <Route path="/test/*" element={<TestPage />} />

                  {/* Main Community Routes - 정식 페이지 */}
                  <Route path="/*" element={<CommunityLayout />} />
                </Routes>
              </main>
            </div>
          </Router>
        </CommunityProvider>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
